import { useState } from 'react';
import { MIXING_CARD_CLASSES } from '../constants/classNames';

/**
 * Plays the reaction's GIF over the beaker. If the file is missing it renders
 * nothing and the SVG scene's own animation carries the reaction.
 */
export default function ReactionGif({ reaction }) {
  const [isGifMissing, setIsGifMissing] = useState(false);
  if (isGifMissing) return null;
  return (
    <img
      className={MIXING_CARD_CLASSES.gif}
      src={reaction.gifPath}
      alt=""
      aria-hidden="true"
      onError={() => setIsGifMissing(true)}
    />
  );
}
